import massEmailTemplatesReducers from './Settings/MassEmailTemplatesSettings/state/reducers';
import importReducer from './Import/state/reducers';

export default {
  massEmailTemplates: massEmailTemplatesReducers,
  import: importReducer,
};
